import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { COMPANY_INFO, SEO_CONFIG } from '../data/companyData';

export default function ForbiddenPage() {
  return (
    <>
      <SEOHead
        title={SEO_CONFIG.forbidden.title}
        description={SEO_CONFIG.forbidden.description}
      />

      <section className="min-h-[70vh] flex items-center justify-center py-20 bg-neutral-50 px-4">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-neutral-900 border border-neutral-800 text-[#DFBF77] text-3xl font-extrabold shadow-sm">
            403
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-neutral-950">
            Adgang nægtet (403)
          </h1>

          <p className="text-base text-neutral-600 max-w-md mx-auto leading-relaxed">
            Du har desværre ikke tilladelse til at tilgå denne ressource. Hvis du mener, dette er en fejl, er du velkommen til at kontakte os.
          </p>

          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto px-6 py-3 rounded-lg bg-neutral-950 hover:bg-[#20252D] text-white font-semibold text-sm transition-all shadow-sm"
            >
              Tilbage til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto px-6 py-3 rounded-lg bg-[#C5A059] hover:bg-[#DFBF77] text-neutral-950 font-bold text-sm transition-all shadow-sm"
            >
              Kontakt os
            </Link>
          </div>

          <div className="pt-6 text-xs text-neutral-500">
            Har du spørgsmål? Ring til os på{' '}
            <a href={COMPANY_INFO.phoneHref} className="font-bold text-neutral-900 whitespace-nowrap">
              {COMPANY_INFO.phoneFormatted}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
